import { Product } from '../../types/Product';
import { MenuSuggestion } from '../../types/Menu';
import { filterBabyProducts } from './filters';
import { AGE_RANGE_DESCRIPTIONS } from './constants';
import { generateBabyMenuPrompt } from './grokPrompts';
import { apiService } from '../../services/apiService';

export const generateBabyMenu = async (
  products: Product[],
  ageRange: string,
  maxPrice: number,
  courseCount: number
): Promise<MenuSuggestion> => {
  const filteredProducts = filterBabyProducts(products, ageRange);
  
  if (filteredProducts.length === 0) {
    return {
      name: `Menú bebé ${ageRange} meses`,
      description: AGE_RANGE_DESCRIPTIONS[ageRange as keyof typeof AGE_RANGE_DESCRIPTIONS],
      products: [],
      recipeSteps: ''
    };
  }

  // Filter by price and randomize selection
  const priceFilteredProducts = filteredProducts
    .filter(p => p.current_price <= maxPrice / courseCount)
    .sort(() => Math.random() - 0.5)
    .slice(0, courseCount * 2);

  const menuName = `Menú bebé ${ageRange} meses`;
  
  try {
    // Generate recipe with Grok
    const prompt = generateBabyMenuPrompt(priceFilteredProducts, ageRange, menuName);
    const response = await apiService.generateRecipe(prompt);
    const recipeSteps = response.choices[0].message.content;

    return {
      name: menuName,
      description: `${courseCount} ${courseCount === 1 ? 'plato nutritivo' : 'platos nutritivos'} - ${
        AGE_RANGE_DESCRIPTIONS[ageRange as keyof typeof AGE_RANGE_DESCRIPTIONS]
      }`,
      products: priceFilteredProducts,
      recipeSteps
    };
  } catch (error) {
    console.error('Error generating baby menu:', error);
    return {
      name: menuName,
      description: AGE_RANGE_DESCRIPTIONS[ageRange as keyof typeof AGE_RANGE_DESCRIPTIONS],
      products: priceFilteredProducts,
      recipeSteps: ''
    };
  }
};